import React from 'react';
import { User } from '../types';
import { Icons } from '../constants';

interface Props {
  user: User;
}

/**
 * Landing screen for a self-registered job applicant. Applicants get an account
 * so the office can contact them and track the application, but no staff access.
 * When an admin changes their type to Employee or Contractor in Users & Access,
 * their next login takes them into the crew workspace.
 */
const ApplicantStatusView: React.FC<Props> = ({ user }) => {
  return (
    <div className="max-w-3xl mx-auto py-10 px-4">
      <div className="bg-white rounded-3xl border border-stone-100 shadow-sm p-8 sm:p-10">
        <div className="w-14 h-14 rounded-2xl bg-gecko/10 text-gecko flex items-center justify-center mb-6">
          <Icons.Education />
        </div>
        <p className="text-[10px] font-black uppercase tracking-widest text-gecko mb-2">Application received</p>
        <h1 className="text-2xl sm:text-3xl font-black text-bark mb-3">
          Thanks, {user.name?.split(' ')[0] || 'there'}.
        </h1>
        <p className="text-stone-600 leading-relaxed mb-6">
          Your application is in the GreenTree queue. An admin will review it and contact you at{' '}
          <span className="font-bold text-bark">{user.email}</span>. If you are approved, your account will be
          upgraded to the crew workspace — no new sign-up needed.
        </p>

        <div className="bg-stone-50 rounded-2xl border border-stone-100 p-5 mb-6">
          <h2 className="text-xs font-black uppercase tracking-widest text-stone-500 mb-3">While you wait</h2>
          <ul className="space-y-2 text-sm text-stone-600">
            <li>• Browse the free <a href="/worksheets" className="font-bold text-palm hover:underline">arborist worksheets</a>.</li>
            <li>• Learn about our <a href="/#services" className="font-bold text-palm hover:underline">tree care services</a>.</li>
            <li>• Questions? Call <a href="tel:7063267034" className="font-bold text-palm hover:underline">(706) 326-7034</a>.</li>
          </ul>
        </div>

        <p className="text-[11px] text-stone-400">
          Signed in as {user.email}. Use the sign-out button in the sidebar if you need to switch accounts.
        </p>
      </div>
    </div>
  );
};

export default ApplicantStatusView;
